import React, { useMemo } from "react";
import useSeo from "../seo/useSeo";
import useJsonLd from "../seo/useJsonLd";
import PdfToImages from "../components/PdfToImages";

export default function PdfToPngPage() {
  useSeo({
    title: "PDF en PNG – Convertir un PDF en images PNG | pdf-convert.fr",
    description:
      "Convertissez un PDF en images PNG (qualité maximale). Gratuit, rapide, traitement 100% local.",
    canonical: "https://pdf-convert.fr/pdf-png",
  });

  // Breadcrumb
  const breadcrumbJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Accueil",
          item: "https://pdf-convert.fr/home",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Conversion",
          item: "https://pdf-convert.fr/conversion",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "PDF en PNG",
          item: "https://pdf-convert.fr/pdf-png",
        },
      ],
    }),
    []
  );

  useJsonLd("breadcrumb-pdf-png", breadcrumbJsonLd);

  // FAQ items
  const faqItems = useMemo(
    () => [
      {
        q: "Comment convertir un PDF en PNG ?",
        a: "Importez votre PDF puis lancez la conversion. Chaque page est exportée en image PNG téléchargeable.",
      },
      {
        q: "Le PNG est-il de meilleure qualité que le JPG ?",
        a: "Oui, le PNG est sans perte et conserve davantage de détails. En contrepartie, le fichier est souvent plus lourd.",
      },
      {
        q: "Mes fichiers sont-ils envoyés sur un serveur ?",
        a: "Non. Tout se fait localement dans votre navigateur, sans upload.",
      },
    ],
    []
  );

  // FAQ JSON-LD
  const faqJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((it) => ({
        "@type": "Question",
        name: it.q,
        acceptedAnswer: { "@type": "Answer", text: it.a },
      })),
    }),
    [faqItems]
  );

  useJsonLd("faq-jsonld-pdf-png", faqJsonLd);

  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>PDF → PNG</h1>
      <p style={{ textAlign: "center", color: "#666" }}>
        Conversion en PNG (qualité maximale). Aucun envoi, tout se fait dans
        votre navigateur.
      </p>

      <PdfToImages defaultFormat="png" />
    </main>
  );
}
